import React from "react";
import { Text } from "basis";
import { Link } from "../../";
import { MONTHLY_FEES, RATES } from "./constants";
import { currencyFormat } from "../../../utils";
import { COLOR } from "../../theme";

export const Deferred = ({
  learnMoreURL,
  onLearnMoreClick = () => { },
  currency,
  au,
  nz,
}) => {
  const monthlyPrice = currencyFormat(MONTHLY_FEES[currency]);

  const AU = () => (
    <>
      <Text textStyle="body2" margin="0 0 3" color={COLOR.LATITUDE_BLUE_INDIGO}>
        <strong>
          Make payments at any time it suits you during the plan period.
        </strong>{" "}
      </Text>
      <Text textStyle="body2" margin="0 0 3" color={COLOR.LATITUDE_BLUE_INDIGO}>
        <strong>Monthly credit card fee (currently ${monthlyPrice})</strong> will apply.
        After the interest free plan ends interest will be charged on any
        outstanding balance at the expired plan rate, currently {RATES.GEM_VISA_AU}%
        p.a. (subject to change).
      </Text>
    </>
  );

  const NZ = () => (
    <>
      <Text textStyle="body2" margin="0 0 3">
        <strong>
          Make payments at any time it suits you during the plan period.
        </strong>
      </Text>

      <Text textStyle="body2" margin="0 0 3">
        Interest applies on any outstanding balance at the end of your plan period. Interest (currently {RATES.GEM_VISA_NZ}% p.a.) applies after any interest free plan expires.
      </Text>

      {/* {!window.location.pathname.includes('/payment/complete') && (
        <Link href={learnMoreURL} onClick={onLearnMoreClick} newTab smallFont>
          Learn more on Short Term Instalment Interest Free
        </Link>
      )} */}
    </>
  );

  return (
    <>
      {au && <AU />}
      {nz && <NZ />}
    </>
  );
};